import { RefObject, useEffect } from "react";

const useInert = ({ ref, inert }: { ref: RefObject<HTMLElement | null>; inert: boolean }) => {
	useEffect(() => {
		if (ref.current) {
			if (inert) {
				ref.current.setAttribute('inert', '');
			} else {
				ref.current.removeAttribute('inert');
			}
		}
	}, [inert, ref]);
};

export default useInert;